import { trailingSlash } from "./helpers";
import _ from "lodash";

export default {
  created: function() {
    this.initCountriesList();
  },
  data() {
    return {
      countries: [],
    };
  },
  computed: {
    countriesURL() {
      return trailingSlash(process.env.VUE_APP_PROGRAMS_URL) + "api/countries";
    },
  },
  methods: {
    initCountriesList() {
      fetch(this.countriesURL)
        .then(response => response.json())
        .then(data => {
          this.countries = Object.values(data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    /**
     * Triggered when the search text changes on vSelect component for country list
     *
     * @param search  {String}    Current search text
     * @param loading {Function}  Toggle loading class
     */
    searchCountries(search, loading) {
      loading(true);
      this.throttledSearchCountries(search, loading, this);
    },
    throttledSearchCountries: _.debounce((search, loading, vm) => {
      fetch(vm.countriesURL + "?search=" + encodeURIComponent(search))
        .then(response => response.json())
        .then(data => {
          vm.countries = Object.values(data);
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    }, 250),
  },
};